import React from 'react';
import Box from '@mui/material/Box';

/**
 * A non-clickable row inside an MUI <Menu> (a section label, a note, a
 * signed-in header). MenuList skips it for focus and the arrow keys, so the
 * first real item still gets focus when the menu opens.
 */
export default function MenuHeading({ children, sx }) {
  return (
    <Box component="li" role="presentation" sx={sx}>
      {children}
    </Box>
  );
}

MenuHeading.muiSkipListHighlight = true;
